import { IconArrowRight } from "@tabler/icons-react";
import { Button, Group } from "@/components/ui";

interface Props {
  puedeContinuar: boolean;
  onContinuar: () => void;
}

/**
 * Botonera del paso "Cargar ZIP" (subtipo Múltiples CFDI).
 *
 * No tiene boton "Volver" porque desde este step no se puede retroceder al
 * paso "Tipo de solicitud" · una vez creada la solicitud, tipo/subtipo
 * quedan fijos por reglas de negocio. La unica salida es continuar al
 * detalle o salir via navbar/sidebar.
 */
export function CargarZipActions({ puedeContinuar, onContinuar }: Props) {
  return (
    <Group justify="flex-end" className="mt-1">
      <Button rightSection={<IconArrowRight size={14} />} disabled={!puedeContinuar} onClick={onContinuar}>
        Continuar al detalle
      </Button>
    </Group>
  );
}
